import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row", "prevButton", "nextButton"]
  static values = { perPage: Number }

  connect() {
    this.page = 0
    this.totalPages = Math.ceil(this.rowTargets.length / this.perPageValue)
    this.update()
  }

  next() {
    if (this.page < this.totalPages - 1) {
      this.page++
      this.update()
    }
  }

  prev() {
    if (this.page > 0) {
      this.page--
      this.update()
    }
  }

  update() {
    const start = this.page * this.perPageValue
    const end   = start + this.perPageValue

    this.rowTargets.forEach((row, index) => {
      row.classList.toggle("hidden", index < start || index >= end)
    })

    this.prevButtonTarget.disabled = this.page === 0
    this.nextButtonTarget.disabled = this.page === this.totalPages - 1
  }
}
